import { render, staticRenderFns } from "./UnitResults.vue?vue&type=template&id=70b884fe&scoped=true"
import script from "./UnitResults.vue?vue&type=script&lang=js"
export * from "./UnitResults.vue?vue&type=script&lang=js"
import style0 from "./UnitResults.vue?vue&type=style&index=0&id=70b884fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b884fe",
  null
  
)

export default component.exports